export default function () {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
    </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const buttons = function (btn1) {
      if (btn1) {
        let btnContainer = '';
        if (btn1) {
          btnContainer = `<a href="${btn1}" class="button">MORE
            </a>`;
        }
        return btnContainer;
      } else {
        return '';
      }
    };

    const template = `
    <div class="swiper-slide">
      <div class="swiper-arrows__button swiper-arrows__button--prev" tabindex="0" role="button"
        aria-label="Previous slide">
        <span> </span>
      </div>
      <div class="swiper-arrows__button swiper-arrows__button--next" tabindex="0" role="button" aria-label="Next slide">
        <span> </span>
      </div>
      <div role="region" class="swiper-image-container swiper-lazy" data-background="${
        slide.ImageWithPath
      }" aria-label="${slide.ImageAlternateText}">
        <div class="swiper-lazy-preloader"></div>
      </div>
      ${
        description
          ? `<div class="swiper-content-container">
        ${description}
        ${buttons(slide.URL)}
      </div>`
          : ''
      }
      
      <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
    </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach((slide, i) => {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    let autoplay = {
      delay: 6000,
    };

    let enableNav = {
      allowSlideNext: true,
    };

    function autoPlayCondition() {
      if (widgetData.length > 1) {
        return autoplay;
        return enableNav;
      } else {
        // class should be created. this can apply also for pagination
        return (autoplay = false);
        return (enableNav = false);
      }
    }

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: '.swiper-arrows__button--next',
        prevEl: '.swiper-arrows__button--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoPlayCondition(),
      allowSlideNext: autoPlayCondition(),
      allowSlidePrev: autoPlayCondition(),
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      $(`#${widgetName}`).remove();
    }
  });
}
